export default function GovernanceSection() {
  return (
    <section id="governance" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left mb-8 sm:mb-10 lg:mb-12">
          <div className="inline-block px-4 py-2 bg-[#0B1F3B]/5 rounded-full mb-4 sm:mb-6">
            <span className="text-sm font-semibold text-[#0B1F3B]">Servizio Avanzato</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-3 sm:mb-4 lg:mb-5 leading-tight text-left">
            Governance del Brand
          </h2>
          <p className="text-sm sm:text-base text-[#1C1C1C]/80 max-w-3xl leading-relaxed">
            Sistema integrato di gestione patrimoniale del marchio con licensing strategico, monitoraggio continuo e ottimizzazione fiscale
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
          <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-5 sm:p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#22C55E] rounded-lg mb-4 sm:mb-5">
              <i className="ri-search-line text-2xl text-white"></i>
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#0B1F3B] mb-2 sm:mb-3">
              Brand Capital Assessment
            </h3>
            <p className="text-sm text-[#1C1C1C]/70 mb-4 sm:mb-5 leading-relaxed">
              Processo strutturato di analisi iniziale che consente di misurare il valore del brand attraverso l'applicazione del Brand Capital Index.
            </p>
            <div className="mb-4">
              <h4 className="font-semibold text-[#0B1F3B] text-sm mb-2">Finalità</h4>
              <ul className="space-y-2">
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Comprendere se il brand rappresenta un costo, un rischio o un asset</span>
                </li>
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Ottenere una prima rappresentazione del capitale di brand</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-5 sm:p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#22C55E] rounded-lg mb-4 sm:mb-5">
              <i className="ri-file-text-line text-2xl text-white"></i>
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#0B1F3B] mb-2 sm:mb-3">
              Brand Capital Report
            </h3>
            <p className="text-sm text-[#1C1C1C]/70 mb-4 sm:mb-5 leading-relaxed">
              Documento tecnico che formalizza i risultati dell'Assessment.
            </p>
            <div className="mb-4">
              <h4 className="font-semibold text-[#0B1F3B] text-sm mb-2">Finalità</h4>
              <ul className="space-y-2">
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Rendere il valore del brand documentabile</span>
                </li>
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Supportare il dialogo con consulenti, stakeholder e partner esterni</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-5 sm:p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#22C55E] rounded-lg mb-4 sm:mb-5">
              <i className="ri-settings-3-line text-2xl text-white"></i>
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#0B1F3B] mb-2 sm:mb-3">
              Brand Capital Framework
            </h3>
            <p className="text-sm text-[#1C1C1C]/70 mb-4 sm:mb-5 leading-relaxed">
              Modello operativo di governance del brand.
            </p>
            <div className="mb-4">
              <h4 className="font-semibold text-[#0B1F3B] text-sm mb-2">Finalità</h4>
              <ul className="space-y-2">
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Trasformare la misurazione in gestione</span>
                </li>
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Dimostrare continuità di controllo sul brand come asset</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-5 sm:p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#22C55E] rounded-lg mb-4 sm:mb-5">
              <i className="ri-user-star-line text-2xl text-white"></i>
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#0B1F3B] mb-2 sm:mb-3">
              Brand Governance Advisory
            </h3>
            <p className="text-sm text-[#1C1C1C]/70 mb-4 sm:mb-5 leading-relaxed">
              Servizio di affiancamento continuativo orientato al controllo e alla crescita del valore di brand.
            </p>
            <div className="mb-4">
              <h4 className="font-semibold text-[#0B1F3B] text-sm mb-2">Finalità</h4>
              <ul className="space-y-2">
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Supportare decisioni strategiche che impattano sul brand</span>
                </li>
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Ridurre il rischio di scelte incoerenti o distruttive di valore</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-5 sm:p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#22C55E] rounded-lg mb-4 sm:mb-5">
              <i className="ri-dashboard-line text-2xl text-white"></i>
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#0B1F3B] mb-2 sm:mb-3">
              Brand Capital Dashboard
            </h3>
            <p className="text-sm text-[#1C1C1C]/70 mb-4 sm:mb-5 leading-relaxed">
              Dashboard di monitoraggio del Brand Capital Index.
            </p>
            <div className="mb-4">
              <h4 className="font-semibold text-[#0B1F3B] text-sm mb-2">Finalità</h4>
              <ul className="space-y-2">
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Rendere il valore del brand osservabile nel tempo</span>
                </li>
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Evidenziare correlazioni tra decisioni aziendali e variazioni del capitale di brand</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-5 sm:p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#22C55E] rounded-lg mb-4 sm:mb-5">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#0B1F3B] mb-2 sm:mb-3">
              Brand Capital Protection
            </h3>
            <p className="text-sm text-[#1C1C1C]/70 mb-4 sm:mb-5 leading-relaxed">
              Servizio di supporto alla tutela del brand come asset economico.
            </p>
            <div className="mb-4">
              <h4 className="font-semibold text-[#0B1F3B] text-sm mb-2">Finalità</h4>
              <ul className="space-y-2">
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Ridurre il rischio legale, fiscale e strategico</span>
                </li>
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Preparare il brand a verifiche, perizie o operazioni straordinarie</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white border border-[#0B1F3B]/10 rounded-lg p-5 sm:p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#22C55E] rounded-lg mb-4 sm:mb-5">
              <i className="ri-lightbulb-line text-2xl text-white"></i>
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#0B1F3B] mb-2 sm:mb-3">
              Brand Capital Strategy
            </h3>
            <p className="text-sm text-[#1C1C1C]/70 mb-4 sm:mb-5 leading-relaxed">
              Servizio strategico avanzato orientato alla valorizzazione economica del brand.
            </p>
            <div className="mb-4">
              <h4 className="font-semibold text-[#0B1F3B] text-sm mb-2">Finalità</h4>
              <ul className="space-y-2">
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Analizzare opzioni di monetizzazione del brand</span>
                </li>
                <li className="flex items-start text-sm text-[#1C1C1C]/70">
                  <i className="ri-check-line text-[#22C55E] mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Supportare operazioni di crescita, investimento o riorganizzazione</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
